import React, { } from 'react';
import {
  Dropdown,
  DropdownProps,
} from 'tea-component';
import ConfirmAndCancel, { IConfirmAndCancelProps } from '@/pages/datalab/components/ConfirmAndCancle';

import './index.scss';

interface IDropdownUIProps extends IConfirmAndCancelProps, Partial<DropdownProps> {
  haveButton?: boolean;
  button: React.ReactNode;
}

const DropdownUI: React.FC<IDropdownUIProps> = ({
  preNode,
  nextNode,
  haveButton,
  button,
  onConfirm,
  onCancel,
  children,
  ...rest
}) => (
  <Dropdown
    button={button}
    {...(rest || {})}
  >
    {(close) => (
      <div>
        {typeof children === 'function' ? children(close) : children}
        {
          haveButton && <ConfirmAndCancel
            bottomPadding={0}
            onConfirm={onConfirm}
            onCancel={onCancel}
            preNode={preNode}
            nextNode={nextNode}
            {...(rest || {})}
          />
        }
      </div>
    )}
  </Dropdown>
);

export default DropdownUI;